// https://github.com/Siddharth11/gradStop.js

import {
  extractHEX,
  extractRGB,
  extractHSL,
  propBezInterpolate,
  returnRGBStr,
  returnHSLStr,
} from './utils';

const GradStop = (options) => {
  if (options.stops <= options.colorArray.length) {
    return options.colorArray;
  }

  const outputArray = [];

  const init = () => {
    switch (options.inputFormat) {
      case 'hex':
        return extractHEX(options.colorArray);
      case 'rgb':
        return extractRGB(options.colorArray);
      case 'hsl':
      default:
        return extractHSL(options.colorArray);
    }
  };

  const colorArray = init();
  const inc = 1.0 / (options.stops - 1);
  let t = 0;

  for (let i = 0; i < options.stops; i += 1) {
    if (options.inputFormat === 'hex' || options.inputFormat === 'rgb') {
      const [r, g, b] = propBezInterpolate(['r', 'g', 'b'])(colorArray)(t);
      outputArray.push(returnRGBStr([r, g, b]));
    } else if (options.inputFormat === 'hsl') {
      const [h, s, l] = propBezInterpolate(['h', 's', 'l'])(colorArray)(t);
      outputArray.push(returnHSLStr([h, s, l]));
    }
    t += inc;
  }

  return outputArray;
};

export default GradStop;
